import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { SearchModel } from '../models/search.model';

@Injectable()
export class SearchService {

    private antiRebound = 500;
    private timestamp   = 0;

    constructor(public apiService: ApiService) {

    }

    search(query: string, model: SearchModel) {
        this.timestamp = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.get('search', 'query=' + query).subscribe(res=> {
                    model.clients  = res.data.clients;
                    model.bikes    = res.data.bikes;
                    model.bills    = res.data.bills;
                    model.services = res.data.services;
                    model.loading = false;
                    if (!model.services)
                        model.services = [];
                }, (_err)=> {
                    this.apiService.error(_err);
                });
            }
        }, this.antiRebound);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/search.service.ts